import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import * as style from './ArticlePersonBlock.module.scss';
import { getRelAttribute } from '../../../utilities';

/**
 * Person block - a single person card.
 */

const contentWrapper = (link, children) => {
  return link ? (
    <a
      href={link?.peopleListHyperlinkTextAndLink?.url}
      title={link?.peopleListHyperlinkTextAndLink?.title}
      target={link?.peopleListHyperlinkTextAndLink?.target}
      rel={getRelAttribute(
        link?.peopleListHyperlinkTextAndLink?.target,
        link?.peopleListHyperlinkTextAndLinkMakeNoFollow
      )}
    >
      {children}
    </a>
  ) : (
    <>{children}</>
  );
};

const ArticlePersonBlock = (props) => {
  const { name, occupation, textBio, imageData, linksHeading, links } = props;

  const globalLink =
    links && links[0]?.makeHeadingAndImageClickable ? links[0] : false;

  return (
    <div className={style.personItem}>
      {occupation && <div className={style.personOccupation}>{occupation}</div>}
      {contentWrapper(
        globalLink,
        <div className={style.personName}>{name}</div>
      )}
      {imageData?.images &&
        contentWrapper(
          globalLink,
          <GatsbyImage
            className={style.personImage}
            image={imageData}
            alt={name}
            title={name}
          />
        )}
      {!!textBio && <div className={style.personBio}>{textBio}</div>}
      {linksHeading && (
        <div className={style.personLinksHeading}>{linksHeading}</div>
      )}
      {links?.length && (
        <div className={style.personLinks}>
          {links?.map((link, index) => (
            <a
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              href={link?.peopleListHyperlinkTextAndLink?.url}
              title={link?.peopleListHyperlinkTextAndLink?.title}
              target={link?.peopleListHyperlinkTextAndLink?.target}
              rel={getRelAttribute(
                link?.peopleListHyperlinkTextAndLink?.target,
                link?.peopleListHyperlinkTextAndLinkMakeNoFollow
              )}
            >
              {link?.peopleListHyperlinkTextAndLink?.title}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
ArticlePersonBlock.defaultProps = {
  links: [],
  linksHeading: '',
  occupation: '',
};

ArticlePersonBlock.propTypes = {
  /**
   * Occupation of a person.
   */
  occupation: PropTypes.string,
  /**
   * Name of a person.
   */
  name: PropTypes.string.isRequired,
  /**
   * Biography of a person.
   */
  textBio: PropTypes.string.isRequired,
  /**
   * Photo of a person (gatsby-image data).
   */
  imageData: PropTypes.object.isRequired,
  /**
   * Heading of links section.
   */
  linksHeading: PropTypes.string,
  /**
   * Links - array of objects
   */
  links: PropTypes.arrayOf(
    PropTypes.shape({
      peopleListHyperlinkTextAndLink: PropTypes.shape({
        target: PropTypes.string,
        title: PropTypes.string,
        url: PropTypes.string,
      }),
      peopleListHyperlinkTextAndLinkMakeNoFollow: PropTypes.bool,
    })
  ),
};

export default ArticlePersonBlock;
